import { Menu, MenuProps, styled } from "@mui/material";

export const ActionMenu = styled((props: MenuProps) => (
  <Menu elevation={0} {...props} />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: 8,
    minWidth: 120,
    color: '#363636',
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '0',
    },
    '& .MuiMenuItem-root': {
      borderRadius: '6px',
      fontSize: '14px',
      fontWeight: '400',
      minHeight: '38px',

      '& .MuiSvgIcon-root': {
        fontSize: 16,
        marginRight: 8,
      },
      '&:active, &:hover': {
        backgroundColor: '#BF295C',
        color: 'white',
      },
    },
  },
}));